import type { TokenResult } from './token-registry.types';

const RWA_TOKEN_LIST_NAME = 'RWA Tokens';

/** Whether a token is blocked by a token list, ignoring the RWA block list. */
export const isTokenBlockedByTokenList = (
  token: Pick<TokenResult, 'tokenListsBlock'> | undefined,
): boolean => !!token?.tokenListsBlock?.some(({ name }) => name !== RWA_TOKEN_LIST_NAME);
